import { Component, TemplateRef, ViewChild } from '@angular/core';
import { LoaderComponent } from '../../../components/layout/loader/loader.component';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute, RouterLink } from '@angular/router';
import { ApiService } from '../../../services/api.service';
import { NgbModal, NgbToast, NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { OrderInvoiceFormComponent } from '../../../components/order/order-invoice-form/order-invoice-form.component';
import { OrderProductFormComponent } from '../../../components/order/order-product-form/order-product-form.component';
import { ConfirmDeleteComponent } from '../../../components/confirm-delete/confirm-delete.component';
import { OrderOrganisationFormComponent } from '../../../components/order/order-organisation-form/order-organisation-form.component';
import { OrderOrganisationSelectComponent } from '../../../components/order/order-organisation-select/order-organisation-select.component';
import { OrderPeriodSelectComponentComponent } from '../../../components/order/order-period-select/order-period-select.component';
import { OrderManagerSelectComponent } from '../../../components/order/order-manager-select/order-manager-select.component';
import { InformationModalComponent } from '../../../components/information-modal/information-modal.component';
import { PageHeaderComponent } from '../../../components/page-header/page-header.component';
import { CustomCheckboxComponent } from '../../../components/custom-checkbox/custom-checkbox.component';
import { OrderShipmentFormComponent } from '../../../components/order/order-shipment-form/order-shipment-form.component';

import { EurPipe } from '../../../pipes/eur.pipe';
import { DutchDatePipe } from '../../../pipes/dutch-date.pipe';
import { StatusPipe } from "../../../pipes/status.pipe";
import { OrderProductEditComponent } from '../../../components/order/order-product-edit-form/order-product-edit-form.component';

@Component({
  selector: 'app-order-detail',
  standalone: true,
  imports: [
    CommonModule,
    NgbDropdown,
    NgbDropdownMenu,
    NgbDropdownItem,
    NgbDropdownToggle,
    NgbPopover,
    RouterLink,
    NgbToast,
    LoaderComponent,
    PageHeaderComponent,
    CustomCheckboxComponent,
    EurPipe,
    DutchDatePipe,
    StatusPipe
  ],
  templateUrl: './order-details.component.html',
  styleUrl: './order-details.component.scss'
})
export class OrderDetailsComponent {
  loading: boolean = false;
  itemsLoading: boolean = false;
  actionsLoading: boolean = false;
  shipmentsLoading: boolean = false;
  shipmentActionLoading: boolean = false;

  item: any | null = null;
  orderItems: any | null = null;
  orderActions: any | null = null;
  shipments: any[] = [];
  shipmentError: string = '';

  allProducts: any | null = null;
  itemId: any | null = null;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private activatedRoute: ActivatedRoute,
    private apiService: ApiService
  ) {
    this.loading = true;
    this.itemsLoading = false;
    let self = this;
    this.getItem().then(function () {
      self.getOrderItems();
    }).then(function () {
      self.getOrderActions();
    }).then(function () {
      self.getShipments();
    });
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params['popup'] === 'add-products') {
        this.openAddProduct();
      }
    })
  }

  editInformation() {
    let self = this;
    const modalRef = this.modalService.open(OrderInvoiceFormComponent, {
      size: 'lg'
    });
    modalRef.componentInstance.modalStyle = true;
    modalRef.componentInstance.item = this.item;
    modalRef.result.then(() => {
      this.getItem().then(function () {
        self.getOrderActions();
      });
    });
  }

  editOrganisation() {
    let self = this;
    const modalRef = this.modalService.open(OrderOrganisationFormComponent, {
      size: 'lg'
    });
    modalRef.componentInstance.modalStyle = true;
    modalRef.componentInstance.item = this.item;
    modalRef.result.then(() => {
      this.getItem().then(function () {
        self.getOrderActions();
      });
    });
  }

  openAddProduct() {
    let self = this;
    const modalRef = this.modalService.open(OrderProductFormComponent, { size: 'lg' });
    modalRef.componentInstance.modalStyle = true;
    modalRef.componentInstance.orderId = this.itemId;
    modalRef.result.then((result) => {
      this.getOrderItems();
    });
  }

  updateOrderItem(orderItem: any) {
    let self = this;
    const modalRef = this.modalService.open(OrderProductEditComponent, { size: 'lg' });
    modalRef.componentInstance.modalStyle = true;
    modalRef.componentInstance.orderId = this.itemId;
    modalRef.componentInstance.orderItem = orderItem;
    modalRef.result.then((result) => {
      this.getOrderItems();
    });
  }

  getItem() {
    let self = this;
    self.itemId = this.activatedRoute.snapshot.paramMap.get('id');

    return this.apiService.get('/office/orders/' + self.itemId).then(function (response: any) {
      self.item = response;
      setTimeout(function () { self.loading = false; }, 200);
    }).catch(function (e) {
      self.loading = false;
    });
  }

  getOrderActions() {
    let self = this;
    if (!self.item.id) {
      return;
    }
    self.actionsLoading = true;
    return this.apiService.get('/office/orders/' + self.item.id + '/actions').then(function (response: any) {
      self.orderActions = response;
      setTimeout(function () { self.itemsLoading = false; }, 400);
    }).catch(function (e) {
      self.actionsLoading = false;
    });
  }

  getOrderItems() {
    let self = this;
    if (!self.item.id) {
      return;
    }
    self.itemsLoading = true;
    return this.apiService.get('/office/orders/' + self.item.id + '/items').then(function (response: any) {
      self.orderItems = response;
      setTimeout(function () { self.itemsLoading = false; }, 400);
    }).catch(function (e) {
      self.itemsLoading = false;
    });
  }

  getShipments() {
    let self = this;
    if (!self.item || !self.item.id) {
      return;
    }

    self.shipmentsLoading = true;
    self.shipmentError = '';
    return this.apiService.get('/office/shipments', { order_id: self.item.id }).then(function (response: any) {
      const shipments = (Array.isArray(response) ? response : (response && response.data ? response.data : []))
        .filter((shipment: any) => String(shipment.order_id) === String(self.item.id));
      self.shipments = shipments.map((shipment: any) => ({
        ...shipment,
        status: shipment.status || 'PENDING',
      }));
      self.shipmentsLoading = false;
    }).catch(function () {
      self.shipments = [];
      self.shipmentsLoading = false;
      self.shipmentError = 'Verzendingen konden niet worden geladen.';
    });
  }

  openShipmentModal(shipment: any | null = null) {
    if (!this.item) {
      return;
    }

    let self = this;
    const modalRef = this.modalService.open(OrderShipmentFormComponent, { size: 'lg' });
    modalRef.componentInstance.order = this.item;
    modalRef.componentInstance.orderItems = this.orderItems || [];
    modalRef.componentInstance.shipment = shipment ? { ...shipment } : null;
    modalRef.result.then((result) => {
      if (result) {
        self.getShipments();
        self.getOrderActions();
      }
    });
  }

  getShipmentStatusLabel(status: string): string {
    const labels: { [key: string]: string } = {
      PENDING: 'Open',
      PROCESSING: 'Verwerken',
      SHIPPED: 'Verzonden',
      DELIVERED: 'Geleverd',
      CANCELLED: 'Geannuleerd',
    };
    return labels[status] || status;
  }

  get hasPhysicalWithoutShipping(): boolean {
    if (!this.item || !this.orderItems) {
      return false;
    }
    const hasPhysical = this.orderItems.some((orderItem: any) => orderItem.product_type === 'physical');
    const shippingCosts = Number(this.item.shipping_costs) || 0;
    return hasPhysical && shippingCosts === 0;
  }

  // --- Shipping cost estimate (replicates NeoShippingModule on the ordering website) ---
  private readonly DEFAULT_ITEMS_PER_BOX = 60;

  // Items per box per shipping category. The ordering website derives these from
  // (int)(categoryCost * 1.09): A 60*1.09=65, B 40*1.09=43, C 30*1.09=32, D 25*1.09=27.
  private readonly SHIPPING_CATEGORY_ITEMS_PER_BOX: { [category: string]: number } = {
    category_a: 65,
    category_b: 43,
    category_c: 32,
    category_d: 27,
  };

  private readonly BOX_RATE_TIERS = [
    { min: 1, max: 1, cost: 12 * 1.09 },
    { min: 2, max: 2, cost: 24 * 1.09 },
    { min: 3, max: 7, cost: 60 * 1.09 },
    { min: 8, max: Infinity, cost: 80 * 1.09 },
  ];

  @ViewChild('shippingPop') shippingPop: NgbPopover | undefined;
  shippingCalcLoading: boolean = false;
  shippingEstimate: number | null = null;
  shippingBreakdown: { totalQuantity: number; itemsPerBox: number; totalBoxes: number } | null = null;
  private eanItemsPerBox: { [ean: string]: number } | null = null;

  calculateShipping() {
    let self = this;
    this.shippingEstimate = null;
    this.shippingBreakdown = null;
    this.ensureShippingMap().then(function () {
      self.computeShippingEstimate();
    });
  }

  private ensureShippingMap(): Promise<void> {
    let self = this;
    if (this.eanItemsPerBox) {
      return Promise.resolve();
    }
    this.shippingCalcLoading = true;
    return this.apiService.get('/office/products?limit=500&direction=asc').then(function (response: any) {
      const products = (response && response.data) ? response.data : [];
      const map: { [ean: string]: number } = {};
      products.forEach(function (product: any) {
        const itemsPerBox = self.SHIPPING_CATEGORY_ITEMS_PER_BOX[product.shipping_category];
        if (product.ean && itemsPerBox !== undefined) {
          map[product.ean] = itemsPerBox;
        }
      });
      self.eanItemsPerBox = map;
      self.shippingCalcLoading = false;
    }).catch(function () {
      self.eanItemsPerBox = {};
      self.shippingCalcLoading = false;
    });
  }

  private itemsPerBoxForEan(ean: string): number {
    if (this.eanItemsPerBox && this.eanItemsPerBox[ean] !== undefined) {
      return this.eanItemsPerBox[ean];
    }
    return this.DEFAULT_ITEMS_PER_BOX;
  }

  private computeShippingEstimate() {
    const physicalItems = (this.orderItems || []).filter(
      (orderItem: any) => orderItem.product_type === 'physical' && Number(orderItem.quantity) > 0
    );

    if (physicalItems.length === 0) {
      this.shippingBreakdown = { totalQuantity: 0, itemsPerBox: this.DEFAULT_ITEMS_PER_BOX, totalBoxes: 0 };
      this.shippingEstimate = 0;
      return;
    }

    const itemsPerBox = Math.min(
      ...physicalItems.map((orderItem: any) => this.itemsPerBoxForEan(orderItem.ean))
    );
    const totalQuantity = physicalItems.reduce((sum: number, orderItem: any) => sum + Number(orderItem.quantity), 0);
    const totalBoxes = Math.ceil(totalQuantity / itemsPerBox);

    let cost = 0;
    for (const tier of this.BOX_RATE_TIERS) {
      if (totalBoxes >= tier.min && totalBoxes <= tier.max) {
        cost = tier.cost;
        break;
      }
    }

    this.shippingBreakdown = { totalQuantity, itemsPerBox, totalBoxes };
    this.shippingEstimate = Math.round(cost * 100) / 100;
  }

  closeShippingPopover() {
    if (this.shippingPop) {
      this.shippingPop.close();
    }
  }

  saveShippingCosts() {
    let self = this;
    if (this.shippingEstimate === null) {
      return;
    }
    this.loading = true;
    const payload = { ...this.item, shipping_costs: this.shippingEstimate };
    delete payload.order_items;
    this.apiService.put('/office/orders/' + this.itemId, payload).then(function () {
      self.closeShippingPopover();
      self.getItem().then(function () {
        self.getOrderActions();
      });
    }).catch(function () {
      self.loading = false;
    });
  }

  formatToDutchEuro(value: any): string {
    const formatter = new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return formatter.format(value);
  }

  deleteOrderItem(id: any) {
    const self = this;

    const modalRef = this.modalService.open(ConfirmDeleteComponent, {
      size: 'lg'
    });
    modalRef.componentInstance.modalStyle = true;
    modalRef.componentInstance.message = "Weet je zeker dat je deze regel wilt verwijderen?";
    modalRef.result.then((result) => {
      this.itemsLoading = true;

      if (result) {
        this.apiService.delete("/office/orders/" + this.itemId + "/items/" + id).then(function (response: any) {
          self.getOrderItems();
        }).catch(function (e) {
        });
      }
    });
  }

  setStatus(status: string) {
    let self = this;
    this.loading = true;
    if (status === 'PROCESSED') {
      this.apiService.put("/office/orders/" + this.itemId + "/process", {
        status: status
      }).then(function (response: any) {
        self.getItem();
      }).catch(function (e) {
      });
    } else {
      this.apiService.put("/office/orders/" + this.itemId + "/status", {
        status: status
      }).then(function (response: any) {
        self.getItem().then(function () {
          self.getOrderActions();
        });
      }).catch(function (e) {
      });
    }
  }

  setPrintStatus(status: string) {
    let self = this;
    this.loading = true;
    this.apiService.put("/office/orders/" + this.itemId + "/print-status", {
      print_status: status
    }).then(function (response: any) {
      self.getItem().then(function () {
        self.getOrderActions();
      });
    }).catch(function (e) {
      self.loading = false;
    });
  }

  cancelOrder() {
    const self = this;

    const modalRef = this.modalService.open(ConfirmDeleteComponent, {
      size: 'md'
    });
    modalRef.componentInstance.modalStyle = true;
    modalRef.componentInstance.message = "Weet je zeker dat je deze bestelling wilt annuleren?";
    modalRef.result.then((result) => {
      this.loading = true;

      if (result) {
        this.apiService.put("/office/orders/" + this.itemId + "/cancel", {}).then(function (response: any) {
          self.router.navigate(['/orders'])
        }).catch(function (e) {
        });
      }
    });
  }

  clear(targetKey: string) {
    const self = this;

    let id = this.item.id;
    let title = '';
    if (targetKey === 'organisation_id') {
      title = 'organisatie';
    } else if (targetKey === 'period_id') {
      title = 'periode';
    } else if (targetKey === 'manager_user_id') {
      title = 'manager';
    } else {
      return;
    }

    const modalRef = this.modalService.open(ConfirmDeleteComponent, {
      size: 'md'
    });
    modalRef.componentInstance.modalStyle = true;
    modalRef.componentInstance.message = "Weet je zeker dat je de " + title + " wilt ontkoppelen?";
    modalRef.result.then((result) => {
      let data: any = {};
      data[targetKey] = '';

      if (result) {
      this.loading = true;
        this.apiService.patch("/office/orders/" + this.itemId, data).then(function (response: any) {
          self.getItem();
          self.loading = false;
        }).catch(function (e) {
          self.loading = false;
        });
      }
    });
  }

  selectPeriod() {
    let self = this;
    const modalRef = this.modalService.open(OrderPeriodSelectComponentComponent, { size: 'lg' });
    modalRef.componentInstance.modalStyle = true;
    modalRef.componentInstance.setItem(this.item);
    modalRef.result.then((result) => {
      this.getItem().then(function () {
        self.getOrderActions();
      });
    });
  }

  selectManager() {
    let self = this;
    const modalRef = this.modalService.open(OrderManagerSelectComponent, { size: 'lg' });
    modalRef.componentInstance.modalStyle = true;
    modalRef.componentInstance.setItem(this.item);
    modalRef.result.then((result) => {
      this.getItem().then(function () {
        self.getOrderActions();
      });
    });
  }

  selectOrganisation() {
    let self = this;
    const modalRef = this.modalService.open(OrderOrganisationSelectComponent, { size: 'xl' });
    modalRef.componentInstance.modalStyle = true;
    modalRef.componentInstance.setItem(this.item);
    modalRef.result.then((organisation) => {
      this.apiService.patch("/office/orders/" + self.item['id'], {
        organisation_id: organisation['id']
      }).then(function (response: any) {
        self.loading = false;
        self.getItem().then(function () {
          self.getOrderActions();
        });
      }).catch(function (e) {
        self.loading = false;
        self.getItem();
      });
    });
  }

  sendConfirmationMail() {
    this.openMailPreviewModal(
      'Verstuur bevestiging',
      'Wil je de bevestigingsmail versturen?',
      "/office/orders/" + this.item['id'] + "/preview-confirmation-mail",
      "/office/orders/" + this.item['id'] + "/send-confirmation-mail"
    );
  }

  sendCompletionMail() {
    this.openMailPreviewModal(
      'Verstuur verwerktmail',
      'Wil je de verwerktmail versturen?',
      "/office/orders/" + this.item['id'] + "/preview-completion-mail",
      "/office/orders/" + this.item['id'] + "/send-completion-mail"
    );
  }

  openMailPreviewModal(title: string, message: string, previewEndpoint: string, sendEndpoint: string) {
    let self = this;
    const modalRef = this.modalService.open(InformationModalComponent, { size: 'xl' });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.cancelButtonText = 'Annuleer';
    modalRef.componentInstance.confirmButtonText = 'Verstuur';
    modalRef.componentInstance.loader = true;

    this.apiService.getText(previewEndpoint).then(function (response: any) {
      modalRef.componentInstance.mailPreviewContent = response;
      modalRef.componentInstance.loader = false;
    }).catch(function () {
      modalRef.componentInstance.previewError = 'Fout bij het laden van de mail preview.';
      modalRef.componentInstance.loader = false;
    });

    modalRef.result.then((success) => {
      if (success) {
        self.loading = true;
        this.apiService.post(sendEndpoint, {
          mail_content: ''
        }).then(function (response: any) {
          self.loading = false;
          self.getItem().then(function () {
            self.getOrderActions();
          });
        }).catch(function (e) {
          self.loading = false;
          self.getItem();
        });
      } else {

      }
    });
  }

  sendReadyMail() {

  }

  deleteOrder() {
    const self = this;

    const deleteModal = this.modalService.open(ConfirmDeleteComponent);
    deleteModal.componentInstance.message = 'Weet je zeker dat je deze bestelling wilt verwijderen?';
    deleteModal.result.then((result) => {
      if (result) {
        this.apiService
          .delete(`/office/orders/${self.item.id}`)
          .then(() => {
            self.router.navigate(['/orders']);
          })
      }
    });
  }

  copyToClipboard(variable: string, event: any) {
    const oldHTML = event.target.innerHTML;

    event.target.innerHTML = "Gekopieërd naar klembord";

    navigator.clipboard.writeText(variable).catch(err => {
      console.error('Failed to copy: ', err);
    });

    setTimeout(() => {
      event.target.innerHTML = oldHTML;
    }, 1000);
  }
}
